import clipboard from '../../assets/icons/clipboard.png'
// import clock from '../../assets/icons/clock.png'
import flag from '../../assets/icons/flag.png'
import layers from '../../assets/icons/layers.png'
import search from '../../assets/icons/search.png'
import pack from '../../assets/icons/pack.png'
import truck from '../../assets/icons/truck.png'

export default [
  {
    title: 'Обработка запроса',
    date: '- 3 дня',
    icon: clipboard,
    descr: '',
    text:
      'Осуществление поиска товаров и их производителей в Китае с индивидуальным подходом <br/> к каждому запросу, исходя из бюджета и пожелания клиента.',
  },
  {
    title: 'Размещение заказа на производстве',
    date: '- 7 дней',
    icon: flag,
    descr: '',
    text:
      'Подписание контракта, утверждение спецификаций, размещение <br/> заказов на производстве, оплата депозита.',
  },
  {
    title: 'Производство товаров',
    date: '- 30-60 дней',
    icon: layers,
    descr: '(в зависимости от сложности продукции)',
    text: 'Контроль качества товаров в процессе производства.',
  },
  {
    title: 'Инспекция готовой продукции',
    date: '- 3 дня',
    icon: search,
    desx: '',
    text:
      'Инспекция готовой продукции на соответствие характеристикам, указанным в спецификации:<br/> <div style={{fontSize: 14}}> - Цвет<br/>- Размер<br/>- Ассортимент<br/>- Качество<br/>- Количество<br/>- Материалы</div><br/> Предоставляется фото и видео отчёт.',
  },
  {
    title: 'Консолидация и отгрузка товаров',
    date: '- 5-7 дней',
    icon: pack,
    descr: '',
    text:
      'Консолидация грузов на складе, услуги хранения, выбор транспортной компании, погрузка, затаможка, подготовка экспортной документации, отгрузка контейнеров.',
  },
  {
    title: 'Транспортировка',
    date: '- 15-45 дней',
    icon: truck,
    descr: '(в зависимости от локации и способов отправки)',
    text:
      'Транспортировка товаров (авиа, карго и контейнерные отправки) до места назначения. </br> </br> Оформление транспортных документов - RWB, Bill of Lading, Invoice, Packing List, спецификации, экспортный контракт.',
  },
]
